import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";

export default function useVolunteers() {
  const { baseurl, token, setIsUnauthorised, AdminId } =
    useGlobalContext();

 const [volunteer, setVolunteer] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------- FETCH VOLUNTEER PROFILE ---------------- */

const fetchVolunteerProfile = useCallback(
  async (volunteerId, silent = false) => {
    if (!volunteerId) return [];

    if (!silent) setLoading(true);

    try {
      const res = await axios.post(
        `${baseurl}/api/VolunteerUser/v1.0/volunteerProfileDetails`,
        { volunteerId },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (res.data.responseCode === "00") {
        const profile = res.data.response;
        setVolunteer(profile ? [profile] : []);
        return profile ? [profile] : [];
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage);
      }

      return [];
    } catch {
      toast.error("Error fetching volunteer profile");
      return [];
    } finally {
      if (!silent) setLoading(false);
    }
  },
  [baseurl, token, setIsUnauthorised]
);


  /* ---------------- CREATE VOLUNTEER ---------------- */

  const createVolunteerApi = async (payload, onSuccess) => {
    try {
      const res = await axios.post(
        `${baseurl}/api/VolunteerUser/v1.0/insertVolunteerDetails`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage);
        onSuccess?.();

        if (res.data.response?.volunteerCode) {
          fetchVolunteerProfile(res.data.response.volunteerCode, true);
        }
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error adding volunteer");
    }
  };

  // fetch all volunters details 

const fetchAllVolunteers = useCallback(
  async (adminId = "", silent = false) => {

    if (!silent) setLoading(true);

    try {
      const res = await axios.post(
        `${baseurl}/api/VolunteerAdmin/v1.0/getAllVolunteerDetails`,
        { adminId },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (res.data.responseCode === "00") {
        const volunteers = res.data.data || [];
        setVolunteer(volunteers);
        return volunteers;
      }

      if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage);
      }

      return [];
    } catch (error) {
      toast.error("Error fetching volunteer details");
      return [];
    } finally {
      if (!silent) setLoading(false);
    }
  },
  [baseurl, token, setIsUnauthorised]
);

/* ---------------- REGISTER VOLUNTEER ---------------- */

const registerVolunteerApi = async (payload, onSuccess) => {
  try {
    const res = await axios.post(
      `${baseurl}/api/VolunteerUser/v1.0/registerVolunteer`,
      payload,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );

    if (res.data.responseCode === "00") {
      toast.success(res.data.responseMessage);
      onSuccess?.();
      return res.data.response;
    }

    if (res.data.responseCode === "401") {
      setIsUnauthorised(true);
    } else {
      toast.error(res.data.responseMessage);
    }

    return null;
  } catch (error) {
    toast.error("Error registering volunteer");
    return null;
  }
};

/* ---------------- UPDATE VOLUNTEER DUTY TYPE ---------------- */

const updateVolunteerDutyTypeApi = async (payload) => {
  try {
    const res = await axios.post(
      `${baseurl}/api/VolunteerUser/v1.0/updateVolunteerDutyType`,
      payload,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );

    if (res.data.responseCode === "00") {
      toast.success(res.data.responseMessage || "Duty updated successfully");
      return true;
    }

    if (res.data.responseCode === "401") {
      setIsUnauthorised(true);
    } else {
      toast.error(res.data.responseMessage);
    }

    return false;
  } catch (error) {
    toast.error("Error updating volunteer duty");
    return false;
  }
};

/* ---------------- UPDATE VOLUNTEER DUTY TIME ---------------- */

const updateVolunteerDutyTimeApi = async (
  volunteerId,
  dutyValue
) => {
  const volunteerSession = sessionStorage.getItem("volunteerData");

  if (!volunteerSession) {
    toast.error("Session expired. Please login again.");
    return false;
  }

  const parsed = JSON.parse(volunteerSession);
  const distributorId = parsed.userId;

  // console.log(" DistributorId being sent:", distributorId);

  try {
    const res = await axios.post(
      `${baseurl}/api/Volunteer/v1.0/updateVolunteerDutyTime`,
      {
        distributorId: distributorId,   
        volunteerId: volunteerId,
        dutyValue: dutyValue,
        device: "",
        userId: "",
        latitude: "",
        longitude: "",
      },
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );

    if (res.data.responseCode === "00") {
      toast.success(res.data.responseMessage || "Duty status updated");
      return true;
    }

    if (res.data.responseCode === "401") {
      setIsUnauthorised(true);
    } else {
      toast.error(res.data.responseMessage);
    }

    return false;
  } catch (error) {
    toast.error("Error updating duty status");
    return false;
  }
};


  return {
    volunteer,
    loading,
    fetchVolunteerProfile,
    fetchAllVolunteers,
    createVolunteerApi,
     registerVolunteerApi, 
     updateVolunteerDutyTypeApi,
     updateVolunteerDutyTimeApi,
  };
}
